module.exports = __webpack_public_path__ + "img/feibiaoN134-2.e71b4c86.png";